import { type Theme, rebrandTheme } from '../lib/theme'

export function useContaTheme(): Theme {
  return rebrandTheme
}
